"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionResultsToJSON = exports.TransactionResultsFromJSONTyped = exports.TransactionResultsFromJSON = void 0;
function TransactionResultsFromJSON(json) {
    return TransactionResultsFromJSONTyped(json, false);
}
exports.TransactionResultsFromJSON = TransactionResultsFromJSON;
function TransactionResultsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'],
        'results': json['results'],
    };
}
exports.TransactionResultsFromJSONTyped = TransactionResultsFromJSONTyped;
function TransactionResultsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'total': value.total,
        'results': value.results,
    };
}
exports.TransactionResultsToJSON = TransactionResultsToJSON;
//# sourceMappingURL=TransactionResults.js.map